module.exports = __webpack_public_path__ + "static/media/PDF_89.02a6c545.pdf";